export default function (_payload, models, verb = "edited") {
  return {
    actor: `user-${models.user.id}`,
    verb: verb,
    object: `course-${models.course.id}`,
    to: [
      `course-edits:course-${models.course.id}`,
      `planbook-edits:planbook-${models.planbook.id}`,
    ],
  }
}
